import { connect } from 'react-redux';
import AddAddressButton from 'components/Address/common/AddAddressButton/AddAddressButton';

const mapDispatchToProps = (dispatch, props) => {
  const { onClick } = props;

  return {
    onClick: address => {
      if (onClick) {
        onClick(address);
      }
    },
  };
};

export default connect((state, props) => ({ ...props }), mapDispatchToProps)(AddAddressButton);
